/**
 * El motivo de un rebote en palabras de quien lleva la campaña.
 *
 * Espejo de `supabase/functions/_shared/motivo-rebote.ts` (rotula el aviso por
 * push y Telegram). Son dos archivos porque Deno no importa el frontend; lo que
 * impide que se separen es `tests/unit/motivo-rebote-espejo.test.ts`. Un
 * código nuevo va en los DOS lados.
 */

const POR_DETALLE: Record<string, string> = {
  '1.1': 'la casilla no existe',
  '1.2': 'el dominio no existe',
  '1.10': 'el dominio no recibe correo',
  '2.1': 'la casilla está deshabilitada',
  '2.2': 'la casilla está llena',
  '4.4': 'el dominio no existe o no recibe correo',
};

const POR_SMTP: Record<string, string> = {
  '550': 'la casilla no existe o no acepta correo',
  '551': 'la casilla no existe o no acepta correo',
  '552': 'la casilla está llena',
  '553': 'la casilla no existe o no acepta correo',
};

export function motivoDeRebote(codigo: string | null | undefined, diagnostico?: string | null): string {
  const c = (codigo ?? '').trim();

  const mejorado = c.match(/^([245])\.(\d{1,3})\.(\d{1,3})$/);
  if (mejorado) {
    const detalle = `${mejorado[2]}.${mejorado[3]}`;
    if (POR_DETALLE[detalle]) return POR_DETALLE[detalle];
    if (mejorado[2] === '7') return 'el servidor del destinatario rechazó el correo';
    if (mejorado[1] === '4') return 'el servidor del destinatario no respondió por ahora';
  }

  if (POR_SMTP[c]) return POR_SMTP[c];

  const d = (diagnostico ?? '').toLowerCase();
  if (/(does not exist|no such user|user unknown|unknown user|recipient address rejected)/.test(d)) {
    return 'la casilla no existe';
  }
  return 'no se pudo entregar';
}
